export declare type SvgInterfaceName =
	"SVGCircleElement"|
	"SVGClipPathElement"|
	"SVGDefsElement"|
	"SVGDescElement"|
	"SVGEllipseElement"|
	"SVGFEBlendElement"|
	"SVGFEColorMatrixElement"|
	"SVGFEComponentTransferElement"|
	"SVGFECompositeElement"|
	"SVGFEConvolveMatrixElement"|
	"SVGFEDiffuseLightingElement"|
	"SVGFEDisplacementMapElement"|
	"SVGFEDistantLightElement"|
	"SVGFEFloodElement"|
	"SVGFEFuncAElement"|
	"SVGFEFuncBElement"|
	"SVGFEFuncGElement"|
	"SVGFEFuncRElement"|
	"SVGFEGaussianBlurElement"|
	"SVGFEImageElement"|
	"SVGFEMergeElement"|
	"SVGFEMergeNodeElement"|
	"SVGFEMorphologyElement"|
	"SVGFEOffsetElement"|
	"SVGFEPointLightElement"|
	"SVGFESpecularLightingElement"|
	"SVGFESpotLightElement"|
	"SVGFETileElement"|
	"SVGFETurbulenceElement"|
	"SVGFilterElement"|
	"SVGForeignObjectElement"|
	"SVGGElement"|
	"SVGImageElement"|
	"SVGLineElement"|
	"SVGLinearGradientElement"|
	"SVGMarkerElement"|
	"SVGMaskElement"|
	"SVGMetadataElement"|
	"SVGPathElement"|
	"SVGPatternElement"|
	"SVGPolygonElement"|
	"SVGPolylineElement"|
	"SVGRadialGradientElement"|
	"SVGRectElement"|
	"SVGStopElement"|
	"SVGSVGElement"|
	"SVGSwitchElement"|
	"SVGSymbolElement"|
	"SVGTextElement"|
	"SVGTextPathElement"|
	"SVGTSpanElement"|
	"SVGUseElement"|
	"SVGViewElement";

/**
 * An array of all known SVGInterface names
 * @type {SvgInterfaceName[]}
 */
const svgInterfaceNames: SvgInterfaceName[] = [
	"SVGCircleElement",
	"SVGClipPathElement",
	"SVGDefsElement",
	"SVGDescElement",
	"SVGEllipseElement",
	"SVGFEBlendElement",
	"SVGFEColorMatrixElement",
	"SVGFEComponentTransferElement",
	"SVGFECompositeElement",
	"SVGFEConvolveMatrixElement",
	"SVGFEDiffuseLightingElement",
	"SVGFEDisplacementMapElement",
	"SVGFEDistantLightElement",
	"SVGFEFloodElement",
	"SVGFEFuncAElement",
	"SVGFEFuncBElement",
	"SVGFEFuncGElement",
	"SVGFEFuncRElement",
	"SVGFEGaussianBlurElement",
	"SVGFEImageElement",
	"SVGFEMergeElement",
	"SVGFEMergeNodeElement",
	"SVGFEMorphologyElement",
	"SVGFEOffsetElement",
	"SVGFEPointLightElement",
	"SVGFESpecularLightingElement",
	"SVGFESpotLightElement",
	"SVGFETileElement",
	"SVGFETurbulenceElement",
	"SVGFilterElement",
	"SVGForeignObjectElement",
	"SVGGElement",
	"SVGImageElement",
	"SVGLineElement",
	"SVGLinearGradientElement",
	"SVGMarkerElement",
	"SVGMaskElement",
	"SVGMetadataElement",
	"SVGPathElement",
	"SVGPatternElement",
	"SVGPolygonElement",
	"SVGPolylineElement",
	"SVGRadialGradientElement",
	"SVGRectElement",
	"SVGStopElement",
	"SVGSVGElement",
	"SVGSwitchElement",
	"SVGSymbolElement",
	"SVGTextElement",
	"SVGTextPathElement",
	"SVGTSpanElement",
	"SVGUseElement",
	"SVGViewElement"
];

/**
 * A set of all known SVG Interface names
 * @type {Set<SvgInterfaceName>}
 */
export const SVG_INTERFACE_NAMES: Set<SvgInterfaceName> = new Set(svgInterfaceNames);